/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { TApiResponse } from '../types';

import { formatDate } from '@utils/functions';
import { TMintHistoryQueryParams } from '@features/sourcing/mint-history/types';
import { formatNumberWithSpaces } from '@utils/formats';

export const getImportHistories = (
	page: number,
	size: number,
	queryParams: Partial<TMintHistoryQueryParams>
): Promise<TApiResponse> => {
	return apiClient.get('/imports', {
		params: {
			page: page,
			pageSize: size,
			query: queryParams,
			sort: '-createdAt',
		},
	});
};

export const useImportHistories = (
	page: number,
	size: number,
	queryParams: Partial<TMintHistoryQueryParams>
) => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: [
			'import-histories',
			{
				page: page,
				size: size,
				queryParams: queryParams,
			},
		],
		staleTime: 500,
		queryFn: () =>
			getImportHistories(page, size, queryParams),
	});

	const updateList = (ImportHistories: any[]) => {
		try {
			if (ImportHistories.length === 0) return [];

			return ImportHistories.reduce(
				(acc: any[], currentItem: any) => {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					const modifiedItem: any = {
						...currentItem,
						importDate: formatDate(
							currentItem.createdAt,
							'DD/MM/YYYY'
						),
						lineCount: formatNumberWithSpaces(
							Number(currentItem.lineCount)
						),
					};
					acc.push(modifiedItem);
					return acc;
				},
				[]
			);
		} catch (error) {
			console.error(
				'An error occurred while processing the list:',
				error
			);
			return [];
		}
	};

	return {
		data:
			data && Array.isArray(data?.rows)
				? updateList(data?.rows)
				: [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
